const EmailStatusCodes = {
  LOGIN: "login",
  CONFIRM_ACCOUNT: "confirmAccount",
  VERIFY_ACCOUNT: "verifyAccount"
};

export default EmailStatusCodes;
